import React from "react";
//#region
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { FileItem, FilePreviewsGridList } from "models/utilTypes/fileUtilsTypes";
//#endregion
//#region compnents
import useImageZoom from "../fileViewer/useImageZoom";
import FilesGridItemImage from "./filesGridItemImage";
import FilesGridItem from "./filesGridItem";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { FileHelper } from "utils/helpers";
import clsx from "clsx";

const FilePreviewsGrid: React.FC<FilePreviewsGridList> = (props) => {
  const [images, setImages] = React.useState<FileItem[]>([]);
  const [files, setFiles] = React.useState<FileItem[]>([]);

  React.useEffect(() => {
    const images: FileItem[] = [];
    const files: FileItem[] = [];

    props.files.forEach((file) => {
      const isImage = FileHelper.isImage(file.fileMeta?.contentType ?? "");
      if (isImage) images.push(file);
      else files.push(file);
    });

    setImages(images);
    setFiles(files);
  }, [props.files]);

  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const getZoomImageDialog = useImageZoom(images, props.getImageContent);

  const onImageClick = (index: number) => {
    dispatch(displayDialog(getZoomImageDialog(index)));
  };

  return (
    <Grid item container className={clsx(cssExports.fileGridList, cssExports.filePreviewsGridList)}>
      <Grid item container spacing={1}>
        <Grid item container spacing={1}>
          {images.map((imageGridItem, index) => {
            return (
              <FilesGridItemImage
                key={`${imageGridItem.id}-${index}`}
                imageIndex={index}
                id={imageGridItem.id}
                name={imageGridItem.name}
                sizeInBytes={imageGridItem.sizeInBytes}
                fileMeta={imageGridItem.fileMeta}
                totalImageCount={images.length}
                getImageContent={props.getImageContent}
                onClick={onImageClick}
              ></FilesGridItemImage>
            );
          })}
        </Grid>

        <Grid item container spacing={1}>
          {files.map((fileGridItem, index) => {
            return (
              <Grid item key={`${fileGridItem.id}-${index}`}>
                <FilesGridItem {...fileGridItem} hideRemove onFileClick={props.onFileClick}></FilesGridItem>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FilePreviewsGrid;
